import React, {ReactNode} from 'react';

import {useIntl} from 'react-intl';
import styled from 'styled-components';

import {SmallActionButton, dimensions, colors} from '@stryd/react-ui';

const MenuContainer = styled.div`
  position: absolute;
  z-index: 1;
  top: calc(100% + 5px);
  left: 0;
  display: none;
  flex-flow: column nowrap;
  align-items: flex-start;
  justify-content: center;
  background-color: ${colors.themes.dark.backgroundLayers[3]};
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0px 5px 8px 2px #1b1b1b;
  transition: 0.2s opacity;
  &:hover {
    cursor: auto;
  }
  &.active {
    display: flex;
  }
  @media screen and (max-width: ${dimensions.breakpoints.mobile}) {
    top: calc(100% - 5px);
    width: 100%;
    align-items: center;
  }
`;

const MenuOptions = styled.div`
  display: flex;
  flex-flow: column nowrap;
  align-items: flex-start;
  justify-content: flex-start;
  font-size: 16px;
`;

const FilterMenuButtons = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  align-self: flex-end;
  margin-top: 10px;
  font-size: 16px;
  button {
    font-size: 16px;
  }
`;

const FilterReset = styled.div`
  color: ${colors.themes.dark.buttonPrimaryText};
  text-align: center;
  display: flex;
  align-items: center;
  transition: 0.2s background-color, 0.2s color;
  margin-right: 10px;
  &:hover {
    cursor: pointer;
    color: ${colors.themes.dark.buttonPrimaryBackground};
  }
  @media screen and (max-width: ${dimensions.breakpoints.tabletLandscape}) {
    margin-bottom: 10px;
  }
`;

type FilterMenuProps = {
  filterId: string;
  menuOpen: boolean;
  onResetClick: (filterId: string) => void;
  onSaveClick: (event: CustomEvent) => void;
  children: ReactNode;
};

export const FilterMenu: React.FC<React.PropsWithChildren<FilterMenuProps>> = ({
  filterId,
  menuOpen,
  onResetClick,
  onSaveClick,
  children,
}) => {
  const intl = useIntl();

  return (
    <MenuContainer className={menuOpen ? 'active' : ''}>
      <MenuOptions>{children}</MenuOptions>
      <FilterMenuButtons>
        <FilterReset
          onClick={() => {
            onResetClick(filterId);
          }}
        >
          {intl.formatMessage({
            id: 'FilterMenu.clear',
            defaultMessage: 'Clear',
          })}
        </FilterReset>
        <SmallActionButton onClick={(event: any) => onSaveClick(event)}>
          {intl.formatMessage({
            id: 'FilterMenu.save',
            defaultMessage: 'Save',
          })}
        </SmallActionButton>
      </FilterMenuButtons>
    </MenuContainer>
  );
};
